const translation = {
	PageSize: 'Sivukoko',
	PageOrientation: 'Sivun suunta',
	Format: 'Muoto',
	DPI: 'DPI',
	Generate: 'Generoi'
};

export default translation;
